
angular.module('jv.addCandidate.controller',[])
    .constant('NATIVE_COUNTRY', 'United States')
    .controller('jvAddCandidateController',['$scope', '$routeParams', 'candidates', '$window','viewFieldsFAC', 'jvTotango', 'newCandidateFormTypeFactory','TemplateLoader','$document','NATIVE_COUNTRY','jvHireUrlService',
        function($scope, $routeParams, candidates, $window, viewFieldsFAC, jvTotango, newCandidateFormTypeFactory, TemplateLoader, $document, NATIVE_COUNTRY, jvHireUrlService) {
            $scope.flags=$scope.flags||{};
            var checkCountLimit;
            var addReqtoCand=[];
            $scope.flags.loading= true;
            $scope.flags.navAway = false;
            $scope.employeeSelect = candidates.employeeSelect;
            $scope.locationMultiSelect = candidates.locationMultiSelect;
            $scope.formProperties = newCandidateFormTypeFactory();
            $scope.formProperties.resume = angular.toJson($scope.formProperties.resume);
            $scope.isRefer = $scope.formProperties.name === 'refer';
            $scope.jobLocations = {};
            $scope.newCand={
                generalApplication: false,
                sendEmail: false,
                sendConfirmationEmail: false
            };
            $scope.candidateListUrl = jvHireUrlService.getCandidateListPageUrl();
            if($scope.isRefer) {
                $document[0].title = i18n['REFER_A_FRIEND'];
            }

            /*@_upload/paste resume section ::{parsed: false,fileId: '',previewText:''}*/
            function ResumeSection(){
                this.uploaded= null;
            }

            //default selection limit text
            $scope.selectionLimitText = '';

            // Modal Information
            $scope.modals = {
                addToReq: {
                    show: false,
                    fetch: false
                }
            };

            //Used to hide all the modals on the page
            $scope.hideModals = function(){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key].show = false;
                });
            };

            var setupFormLoadTemplate = function(action){
                 TemplateLoader.load(action).then(function(){
                     $scope.modals[action].show = true;
                });
             };

            /*status filter option*/
            var statusFilter = [],
                categoryFilter=[],
                statusFilterReferFriend=[],
                defaultStatusFilterOption;

            //Temlate loader Config
            $scope.templates = TemplateLoader.register({
                addToReq: '/jhire/modules/candidates/modals/addToReq.html'
            });

            /**Setting up different modal configs**/
            var getmodalConfig = function(action){
                switch (action) {
                    case 'addToReq':
                    //Add to Req modal config
                    $scope.addToReqModalConfig = {
                        list: {
                            config: {
                                type: 'multiSelect',
                                keyName: 'selectedReqEId',
                                label: i18n['LIST_MODAL_TEXT'],
                                resetFilterOn: 'modals.addToReq.show',
                                errorText: i18n['MODAL_VALIDATION_TEXT'],
                                emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                                columns: [
                                        {
                                            header: i18n['REQUISITION'],
                                            show: true,
                                            key: ['title'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['ID'],
                                            show: true,
                                            key: ['requisitionId']
                                        },
                                        {
                                            header: i18n['STATUS'],
                                            show: true,
                                            key: ['jobState']
                                        },
                                        {
                                            header: i18n['COMPANY'],
                                            show: 'showCompany',
                                            key: ['subsidiary.name']
                                        },
                                        {
                                            header: i18n['CATEGORY'],
                                            show: true,
                                            key: ['category.name'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['LOCATION'],
                                            show: true,
                                            key: ['location.name'],
                                            ellipsis: {
                                                set: true
                                            },
                                            tooltipShow: 'jobLocations',
                                            tooltipTriggerLength: 'jobLocations',
                                            tooltipTriggerClass:'italic',
                                            tooltipBodyList: 'jobLocations',
                                            tooltipBodyListId: ['name']

                                        }
                                    ]
                            },
                            get: {
                                url:'/jhire/action/requisitions?',
                                params:{
                                    page:'0',
                                    q:'',
                                    maxResults:'10',
                                    mine:false
                                },
                                filterReqKey: addReqtoCand,
                                responseKey: 'jobs'
                            },
                            post:{
                                callBack: $scope.addToReq.postReqs,
                                button: {
                                    label: i18n['ADD'],
                                    type: 'button',
                                    classNames:['blue-btn','float-right'],
                                    id:'addToReq-btn'
                                }
                            },
                            filters: [{
                                    label: i18n['STATUS'],
                                    ghostText: i18n['ALL'],
                                    allowClear: true,
                                    width:'w175',
                                    data: statusFilter,
                                    keyName: 'reqsStatusFilter',
                                    defaultTo: defaultStatusFilterOption
                                },
                                {
                                    label: i18n['CATEGORY'],
                                    ghostText: i18n['ALL'],
                                    allowClear: true,
                                    width:'w260',
                                    data: categoryFilter,
                                    keyName: 'reqsCategoryFilter'
                                }
                            ],
                            search : {
                                label: i18n['SEARCH'],
                                placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                                get:{
                                    url: '/jhire/action/requisitions?'
                                }
                            }
                        }
                    };

                    //Add to Req modal config
                    $scope.addToReqModalReferFriendConfig = {
                        list: {
                            config: {
                                type: 'multiSelect',
                                keyName: 'selectedReqEId',
                                label: i18n['LIST_MODAL_TEXT'] + ' ' + $scope.selectionLimitText,
                                maxSelections: parseInt($scope.addToReq.limitSelectionCount,10), // eslint-disable-line radix
                                resetFilterOn: 'modals.addToReq.show',
                                errorText: i18n['MODAL_VALIDATION_TEXT'],
                                emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                                columns: [
                                        {
                                            header: i18n['REQUISITION'],
                                            show: true,
                                            key: ['title'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['ID'],
                                            show: true,
                                            key: ['requisitionId']
                                        },
                                        {
                                            header: i18n['STATUS'],
                                            show: true,
                                            key: ['jobState']
                                        },
                                        {
                                            header: i18n['COMPANY'],
                                            show: 'showCompany',
                                            key: ['subsidiary.name']
                                        },
                                        {
                                            header: i18n['CATEGORY'],
                                            show: true,
                                            key: ['category.name'],
                                            ellipsis: {
                                                set: true
                                            }
                                        },
                                        {
                                            header: i18n['LOCATION'],
                                            show: true,
                                            key: ['location.name'],
                                            ellipsis: {
                                                set: true
                                            },
                                            tooltipShow: 'jobLocations',
                                            tooltipTriggerLength: 'jobLocations',
                                            tooltipTriggerClass:'italic',
                                            tooltipBodyList: 'jobLocations',
                                            tooltipBodyListId: ['name']
                                        }
                                    ]
                            },
                            get: {
                                url:'/jhire/action/requisitions?',
                                params:{
                                    page:'0',
                                    q:'',
                                    maxResults:'10',
                                    mine:false,
                                    postingType:1
                                },
                                filterReqKey: addReqtoCand,
                                responseKey: 'jobs'
                            },
                            post:{
                                callBack: $scope.addToReq.postReqs,
                                button: {
                                    label: i18n['ADD'],
                                    type: 'button',
                                    classNames:['blue-btn','float-right'],
                                    id:'addToReq-btn'
                                }
                            },
                            filters: [{
                                    label: i18n['STATUS'],
                                    ghostText: i18n['ALL'],
                                    allowClear: false,
                                    width:'w175',
                                    data: statusFilterReferFriend,
                                    keyName: 'reqsStatusFilter',
                                    defaultTo: defaultStatusFilterOption
                                },
                                {
                                    label: i18n['CATEGORY'],
                                    ghostText: i18n['ALL'],
                                    width:'w260',
                                    allowClear: true,
                                    data: categoryFilter,
                                    keyName: 'reqsCategoryFilter'
                                }
                            ],
                            search : {
                                label: i18n['SEARCH'],
                                placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                                title: i18n['SEARCH_REQUISITION_OR_ID'],
                                get:{
                                    url: '/jhire/action/requisitions?',
                                    params:{
                                        postingType:1
                                    }
                                }
                            }
                        }
                    };

                    if($scope.isRefer){
                        return $scope.addToReqModalReferFriendConfig;
                    }else{
                        return $scope.addToReqModalConfig;
                    }
                    default:
                }
            };

            //Function to set up form template config.
            var setupFormTemplateConfig = function(action){
                if(statusFilter.length && categoryFilter.length) {
                    $scope.formTemplateConfig = getmodalConfig(action);
                    setupFormLoadTemplate(action);
                } else {
                    //Get and initialize filters for modal and pass as config
                    candidates.getRequistionFilters(function(response){
                        if(response){
                            angular.forEach(response.statusFilter.optionValues,function(status){
                                statusFilter.push(status);
                                if(status.key===1 && status.mine === false){
                                    defaultStatusFilterOption = JSON.stringify(status);
                                    statusFilterReferFriend.push(status);
                                }
                            });
                            categoryFilter = response.filters.Categories;
                            $scope.formTemplateConfig = getmodalConfig(action);
                            setupFormLoadTemplate(action);
                        }
                    });
                }
            };

            //Used to show the modals
            $scope.showModals = function(modal){
                $scope.modals[modal].fetch = true;
                setupFormTemplateConfig(modal);

            };

            $scope.resumeArea = {
                /*@_file-upload mode will be selected by default*/
                file: new ResumeSection(),
                text: null,
                /*@_switch back to file-upload mode*/
                clear: function(){
                    this.file=new ResumeSection();
                    this.text=null;
                    $scope.pastedText='';
                },
                /*@_switch to paste-text mode*/
                swtch: function(){
                    this.file=null;
                    this.text=new ResumeSection();
                },
                /*@_get current active mode*/
                getActive: function(){
                    return this.file?'file':'text';
                },
                /*@_parse pasted text*/
                parseText: function(content){
                    $scope.flags.loading=true;
                    candidates.parseResumeContent({content:content}, function(response){
                        if(response.resourceInfo){
                            $scope.resumeArea.files={};
                            $scope.resumeArea.files[response.resourceInfo.eid]={
                                'resourceInfo': response.resourceInfo
                            };
                        }
                        $scope.flags.loading=false;
                    }, $scope.formProperties.parseResumeURL);
                },
                /*@_get post data*/
                getData: function(){
                    var data={};
                    if(this.file && this.file.uploaded){
                        data.resumeId=this.file.uploaded.fileId;
                        data.content=this.file.uploaded.parsed ? this.file.uploaded.previewText : '';
                    }else if(this.text && this.text.uploaded){
                        data.content=this.text.uploaded.previewText;
                    }
                    return data;
                },
                /*@_set data*/
                setData: function(uploadedFiles){
                    if(!$.isEmptyObject(uploadedFiles)){
                        angular.forEach(uploadedFiles, function(resume){
                            //Converting '/n' to <br> . Bug16227 NV
                            //Since the formatting is lost
                            var regex = new RegExp(/[\n\r]/g);
                            if(regex.test(resume.resourceInfo.fileContent)){
                                resume.resourceInfo.fileContent  = ($('<div></div>').text(resume.resourceInfo.fileContent).html()).replace(/\n/g, '<br/>');
                                //resume.resourceInfo.fileContent = resume.resourceInfo.fileContent.replace('\n','<br>');
                            }
                            if(resume.resourceInfo.fileContent && resume.resourceInfo.fileContent !== '' && resume.resourceInfo.fileContent !== 'null'){
                                /*@_resume parsed*/
                                $scope.resumeArea[$scope.resumeArea.getActive()].uploaded={
                                    parsed: true,
                                    fileId: resume.resourceInfo.eid,
                                    previewText: resume.resourceInfo.fileContent+'&nbsp;'
                                };
                            }else{
                                /*@_resume not-parsed*/
                                $scope.resumeArea[$scope.resumeArea.getActive()].uploaded={
                                    parsed: $scope.resumeArea.text !== null ? true : false,
                                    fileId: $scope.resumeArea.file !== null ? resume.resourceInfo.eid :'',
                                    previewText: $scope.resumeArea.file !==null ? '': $scope.pastedText
                                };
                            }
                            if(resume.resourceInfo.formFieldModel){
                                $scope.candidateFields.fieldParsing(resume.resourceInfo.formFieldModel);
                            }
                        });
                    }else{
                        this.clear();
                    }
                }
            };

            $scope.$watch('resumeArea.files',
                function(newVal){
                    $scope.resumeArea.setData(newVal);
                }
            );

            /*
            * removed deep watch from top and added a separate one
            * to clear resume-area when uploaded-file is deleted.
            */
            $scope.$watch(
                function(){
                    return !$.isEmptyObject($scope.resumeArea.files);
                },
                function(newVal){
                    if(!newVal){
                        $scope.resumeArea.clear();
                    }
                }
            );

            /*Get candidate fields Implemented as directive: refer jv.cand.ViewFields.js*/
            $scope.candidateFields={
                viewFields:{},
                startValidation: false,
                settings:{
                    mergeFirstLastName: false
                },
                /*Parsing resume content and populating fields*/
                fieldParsing: function(fieldIdValue){
                    $scope.resumeArea.requiredError = false;
                    var countryField,stateField;
                    angular.forEach(this.viewFields, function(field){

                        if(fieldIdValue[field.fieldId] && !field.value){
                            var parsedValue=fieldIdValue[field.fieldId];
                            /*parsed value's length should be less than equal to field length.. if not trim it..*/
                            if(field.length && field.length <=parsedValue.length){
                                parsedValue=parsedValue.substring(0, field.length);
                            }
                            field.value=parsedValue;
                            //
                            if(field.fieldId === -7 || field.fieldId === -36){
                                if (field.fieldId === -7){
                                    countryField = field;
                                }
                                if (field.fieldId === -36){
                                    stateField = field;
                                }

                                if($('#fieldid'+field.EId)){
                                    $('#fieldid'+field.EId).trigger('change.select2');
                                }
                                //changeCountry($scope.candidateFields.viewFields,field.value)
                                if(field.fieldId === -7){
                                    angular.forEach($scope.candidateFields.viewFields, function(vField){
                                        if(vField.fieldId === -36){
                                            vField.fieldType = field.value === NATIVE_COUNTRY?'DropDown':'Name';
                                        }
                                    });
                                    if($('#fieldid'+field.EId)){
                                        $('#fieldid'+field.EId).val(field.value).trigger('change.select2');
                                    }
                                }
                            }
                        }
                    });

                    if(stateField  && !countryField ){
                        stateField.value = '';
                        $('#fieldid'+stateField.EId).trigger('change');
                    }

                },
                getURL: $scope.formProperties.url,

                /*this object binds to jvViewField directive's scope object which evantually binds to actual BE response.*/
                /*expected flags include allowGeneralApplication:<bool>, jobLimitForReferAFriend:<number>*/
                formSettings: {}
            };

            $scope.$watch('candidateFields.viewFields', function(newVal, oldVal){
                if(oldVal && newVal && angular.isArray(newVal)){
                    //setting navFlag once view-fields are loaded. This will enable navugation message on page
                    $scope.flags.navAway = true;
                    $scope.flags.loading = false;
                    /**Resume field comes as part of viewFields JSON now but UI doesn't honor the order here*/
                    /**hence removing resume fields to get rendered on form**/
                    if(angular.isUndefined($scope.resumeArea.required)){
                        $scope.resumeArea.required = false;
                        $scope.resumeArea.resumeHelpTextFound = false;
                        angular.forEach(newVal, function(field){
                            if(field.fieldId === -16){
                                $scope.resumeArea.required = field.required;
                                field.hide=true;

                                if (field.instructions) {
                                    $scope.resumeArea.resumeHelpTextFound = true;
                                    $scope.resumeArea.resumeHelpText = field.instructions;
                                    $scope.resumeArea.resumeHelpTitle = field.name;
                                }
                            }
                        });
                    }
                    /*initializing it here as this will be called only when response is fully loaded*/
                    $scope.addToReq.showGeneralAppCheck = $scope.candidateFields.formSettings.allowGeneralApplication;
                    $scope.addToReq.hasAccessToAddToReq = $scope.candidateFields.formSettings.allowAddCandidateToReq;
                    $scope.addToReq.limitSelectionCount = $scope.candidateFields.formSettings.jobLimitForReferAFriend;
                    $scope.addToReq.showMultipleLocations = $scope.candidateFields.formSettings.ShowMultipleLocations;
                    $scope.addToReq.shareReferralStatus = $scope.candidateFields.formSettings.shareReferralStatus;
                    //set the selection limit help text if this property is set in the admin
                    if($scope.candidateFields.formSettings.jobLimitForReferAFriend){
                        $scope.selectionLimitText = '(' +$scope.i18n['LIST_MODAL_TEXT_REFER']+ ' ' + $scope.addToReq.limitSelectionCount +')';
                    }
                }
            });


            /*@_ application source is implemented as separate controller, refer: jv.Cand.AppSource.js*/
            $scope.appSource={
                editMode:true,
                getData: function(){
                    return $scope.appSource.validate();
                }
            };

            var checkForGeneralApplication = function(){
                return ($.isEmptyObject($scope.addToReq.allReqs) ? ($scope.candidateFields.formSettings.allowGeneralApplication) : false);
            };

            /*@_ addToRequistion: core functionality is implemented as separate controller. refer: jv.Cand.AddToReq.js */
            $scope.addToReq = {
                allReqs:{},
                newCandidate: true,
                showGeneralAppCheck: true,

                /*@_pre-populating requisition if passed in URL, this is self called function*/
                reqFromReqDetails: function(jobIds){
                    if(jobIds){
                        var jobIdParam='j='+jobIds;
                        candidates.getReqDetails(jobIdParam,function(data,code){
                            if(code === 200){
                                var req = {
                                    requisitionId: data.jobDetails.requisitionId,
                                    title: data.jobDetails.title,
                                    EId: data.jobDetails.EId
                                };
                                /*@push this to req list to show it on UI*/
                                $scope.addToReq.allReqs[req.EId]=req;
                                $scope.addToReq.showGeneralAppCheck = false;
                            }
                        });
                    }
                },

                /*@_override this method for post response*/
                postReqs: function(modalData){
                    $scope.modalData = modalData.selectedReqEId;
                    for(var reqEId in modalData.selectedReqEId){
                        if(modalData.selectedReqEId[reqEId]){
                            for(var i=0; i < modalData.allItems.length; i++){
                                 if(reqEId === modalData.allItems[i].EId){
                                    $scope.addToReq.allReqs[reqEId] = modalData.allItems[i];
                                    break;
                                }
                            }
                        }else{
                            //If user unchecks the req remove it from the list
                            delete $scope.addToReq.allReqs[reqEId];
                        }
                    }
                    $scope.addToReq.showGeneralAppCheck = checkForGeneralApplication();
                    checkCountLimit = Object.keys($scope.addToReq.allReqs).length;
                    addReqtoCand=$scope.addToReq.allReqs;
                    $scope.requisitionCount = $scope.addToReq.limitSelectionCount;
                    $scope.hideModals();
                },

                /*@_remove selected requisitions from addToReq modal selected requisitions*/
                clearSelectedReq: function(reqId){
                    if($scope.addToReq.selectedReq){
                        delete $scope.addToReq.selectedReq[reqId];
                        delete $scope.addToReq.selectedReqsDetail[reqId];

                    }
                    if($scope.addToReq.allReqs) {
                        delete $scope.addToReq.allReqs[reqId];
                        delete $scope.modalData[reqId];
                    }
                    $scope.addToReq.showGeneralAppCheck = checkForGeneralApplication();
                    checkCountLimit=Object.keys($scope.addToReq.allReqs).length;
                    addReqtoCand=$scope.addToReq.allReqs;
                    if(checkCountLimit <= $scope.addToReq.limitSelectionCount){
                             $scope.checkValidation = false;
                             $scope.showMessage = false;
                    }
                },
                isReqsInvalid: function(){
                    var validReqs= $.isEmptyObject($scope.addToReq.allReqs) && $scope.newCand.generalApplication===false;
                    return $scope.candidateFields.startValidation && validReqs;
                },
                getData: function(){
                    var data={};
                    var jobIds=[];
                    var jobLocationIds={};
                    if(!$.isEmptyObject($scope.addToReq.allReqs)){
                        angular.forEach($scope.addToReq.allReqs, function(req, eid){
                            jobIds.push(eid);
                            var locationIds = [];
                            angular.forEach($scope.jobLocations[eid], function(location){
                                locationIds.push(location.EId);
                            });
                            jobLocationIds[eid] = locationIds.join(',');
                            // jobLocationIds[eid] = locationIds;
                        });
                        data['j'] = jobIds.join(',');
                        data['jl'] = JSON.stringify(jobLocationIds);
                        // data['j'] = jobIds;
                        // data['jl'] = jobLocationIds;
                    }
                    return data;
                },
                checkOnLimit: true,
                disableOnLimit: function(reqEId) {
                    if($scope.candidateFields.formSettings.jobLimitForReferAFriend) {
                        if($scope.addToReq.selectedReq) {
                            /*check for disabling checkbox only when selected checkboxes reached limit*/
                            if(window.objectSize($scope.addToReq.selectedReq) >= $scope.candidateFields.formSettings.jobLimitForReferAFriend) {
                                /*checkbox once checked, later unchecked will still has entry in object as false. hence needs to check for property value as true*/
                                var count = 0;
                                angular.forEach($scope.addToReq.selectedReq, function(reqCheckBox) {
                                    count = reqCheckBox ? count+1 : count;
                                });
                                if($scope.candidateFields.formSettings.jobLimitForReferAFriend === count) {
                                    return !$scope.addToReq.selectedReq[reqEId];
                                }
                            }
                        }
                    }
                    return false;
                }
            };

            $scope.addToReq.reqFromReqDetails($routeParams.jobIDs);

            $scope.getFormUploadData = function(viewFields){
                var formUploads={};
                //Get cover letter and attachment information, if fields exists
                angular.forEach(viewFields, function(field){
                    //-61: Attachments
                    if(field.fieldId === -61){
                        var idArray=[];
                        angular.forEach(field.value, function(file,index){
                            idArray.push(index);
                        });
                        formUploads.attachmentIds= idArray.join(',');
                    }
                    //-15: Cover Letter
                    if(field.fieldId === -15){
                        if(!field.text){
                            if(field.value && angular.isObject(field.value)){
                                angular.forEach(field.value, function(file,index){
                                    formUploads.coverLetterId= index;
                                    formUploads.coverLetterContent = file.resourceInfo ? file.resourceInfo.fileContent : '';
                                });
                            }
                        }else{
                            formUploads.coverLetterContent = field.text;
                        }
                    }
                });
                return formUploads;
            };


            $scope.prepareData = function(){
                var data = viewFieldsFAC.validateFields($scope.candidateFields.viewFields);
                var fieldData = data && $.param(data);
                var source={};
                if(!$scope.isRefer){
                    source = $scope.appSource.validate();
                    if(source.error){
                        $scope.appSource.showError = true;
                        $scope.appSource.invalidMsg = source.error;
                    }else{
                        $scope.appSource.showError = false;
                        $scope.appSource.invalidMsg = '';
                    }
                }
                 if($scope.addToReq.limitSelectionCount === 0 && !$scope.newCand.generalApplication){
                             $scope.showMessage = true;
                             return '';
                }
                else{
                 if(checkCountLimit > $scope.addToReq.limitSelectionCount){
                             $scope.checkValidation = true;
                             return '';
                   }
                }
                if(!fieldData || source.error || $scope.addToReq.isReqsInvalid()){
                    return '';
                }

                var uploads = $scope.resumeArea.getData();
                if(!$.isEmptyObject(uploads)){
                    angular.extend(data, uploads);
                } else {
                    if($scope.resumeArea.required) {
                        $scope.resumeArea.requiredError = true;
                        return '';
                    }
                }
                if(!$.isEmptyObject(source)) {
                    angular.extend(data, source);
                }
                var uploadData = $scope.getFormUploadData($scope.candidateFields.viewFields);
                if(!$.isEmptyObject(uploadData)){
                    angular.extend(data, uploadData);
                }

                var requisitions= $scope.addToReq.getData();
                if(!$.isEmptyObject(requisitions)){
                    angular.extend(data, requisitions);
                }
                angular.extend(data,
                    {'generalApplication': $scope.newCand.generalApplication},
                    {'sendEmail': $scope.newCand.sendConfirmationEmail},
                    {'checkDuplicateCandidate':'true'});
                return data;
            };

            $scope.prepareAgencyData = function() {
                var data = viewFieldsFAC.validateFields($scope.candidateFields.viewFields);
                var postData =  $.param(data);
                if(!postData) {
                    return;
                }
                var uploads = $scope.resumeArea.getData();
                if(!$.isEmptyObject(uploads)){
                    angular.extend(data, uploads);
                } else {
                    if($scope.resumeArea.required) {
                        $scope.resumeArea.requiredError = true;
                        return '';
                    }
                }
                var uploadData = $scope.getFormUploadData($scope.candidateFields.viewFields);
                if(!$.isEmptyObject(uploadData)){
                    angular.extend(data, uploadData);
                }
                return data;
            };

            var showDuplicateEmailError = function(data) {
                /*@show modal for duplicate email-id*/
                $scope.dupCandModal = {};
                $scope.dupCandModal.show = true;
                $scope.dupCandModal.data = data;
                $scope.disableDupCandAdd = true;
                var associatedReqsIds = [];
                angular.forEach(data.associatedRequisitions,function(obj){
                    if(obj.job.EId){
                        associatedReqsIds.push(obj.job.EId);
                    }
                    else{
                        //Associated job has no Job EId meaning its a general Application.
                        //Now we check if user is trying to create a general application
                        if($scope.addToReq.showGeneralAppCheck){
                            $scope.duplicateGeneralApplicationCreated = true;
                        }
                    }
                });
                $scope.uniqueReqsIds = [];
                //added cand to general application
                if($scope.addToReq.showGeneralAppCheck && $scope.newCand.generalApplication && !$scope.duplicateGeneralApplicationCreated){
                    var req = {
                        title  : 'General Application'
                    };
                    $scope.uniqueReqsIds.push(req);
                    $scope.disableDupCandAdd = false;
                }else{
                    //added cand to a requisition
                    angular.forEach($scope.addToReq.allReqs,function(req,reqEId){
                        if(reqEId && !$scope.contains(reqEId,associatedReqsIds)){
                            $scope.disableDupCandAdd = false;
                            $scope.uniqueReqsIds.push($scope.addToReq.allReqs[reqEId]);
                        }
                    });
                }
            };

            $scope.saveCandidate = function(){
                $scope.candidateFields.startValidation = true;
                //Replacing the br's back to /n NV Bug 17127
                var regex = /<br *\/?>/gi;
                if($scope.resumeArea.file && $scope.resumeArea.file.uploaded && $scope.resumeArea.file.uploaded.previewText){
                    $scope.resumeArea.file.uploaded.previewText = $scope.resumeArea.file.uploaded.previewText.replace(regex,'\n');
                }else{
                    $scope.pastedText = $scope.pastedText.replace(regex,'\n');
                }
                $scope.saveCandData = $scope.formProperties.name === 'agency' ? $scope.prepareAgencyData() : $scope.prepareData();
                if(!$scope.disableSaveCandidate && $scope.saveCandData){
                    $scope.disableSaveCandidate = true;
                    $scope.flags.loading = true;
                    $scope.flags.navAway = false;
                    candidates.addCandidate($scope.saveCandData, $scope.formProperties.url, function(data,code){
                        if(data) {
                            switch($scope.formProperties.name) {
                                case 'candidate':
                                case 'refer':
                                    if(data.msgInfo === 403) {
                                        $scope.checkValidation = true;
                                    } else if(data.msgInfo === 206) {
                                        showDuplicateEmailError(data, code);
                                    } else if(data.msgInfo === 200) {
                                        $scope.saveCandidateSuccess(data, code);
                                    }
                                    break;
                                case 'agency':
                                    if(data.msgInfo === 206){
                                        $scope.showAgencyCandidateError(data.msgError, code);
                                    } else if(data.msgInfo === 200) {
                                        $scope.saveAgencyCandidateSuccess(data, code);
                                    }
                                    break;
                                default:
                            }
                        }
                       $scope.flags.loading = false;
                    });
                }
            };

            $scope.showAgencyCandidateError = function(error) {
                if(!error){
                    error = i18n['DUPLICATE_CANDIDATE_ERROR'];
                }
                $scope.$root.modal = {
                    show:true,
                    cancel: function(){$scope.$root.modal.show = false;},
                    buttons:[
                        {
                            label: i18n['OK'],
                            title:i18n['OK'],
                            click: function(){ $scope.$root.modal.show = false;},
                            'class': 'btn cancel'
                        }
                    ],
                    title: i18n['AGENCY_CANDIDATE'],
                    body: error
                };
            };

            $scope.saveAgencyCandidateSuccess = function(){
                $scope.cancel();
            };

            $scope.contains = function(item,arr){
                var len = arr.length;
                for(var i=0 ; i<len; i++){
                    if(arr[i] === item){
                        return true;
                    }
                }
                return false;
            };

            /*Save candidate after duplicate detection*/

            $scope.saveDuplicateCandidate = function(){
                $scope.saveCandData['checkDuplicateCandidate'] = false;
                $scope.flags.loading = true;
                candidates.addCandidate($scope.saveCandData, $scope.formProperties.url, function(data,code){
                    if(data && code === 200){
                        $scope.saveCandidateSuccess(data, code);
                    }
                });
                $scope.dupCandModal.show = false;
            };

            /*Hide duplicate Candidate Modal*/
            $scope.hideDupCandModal = function(){
                $scope.dupCandModal.show = false;
                $scope.disableSaveCandidate = false;
            };

            //Takes user to the details page of the recently created application
            $scope.goToCandDetails = function(application){
                var applicationID = application[0].EId;
                $window.location = jvHireUrlService.getApplicationDetailsDefaultTabUrl(applicationID,true);
            };

            //This method is used to show the cand application modal
            $scope.showCandApplicationsModal = function(data){
                if(data && data.applications) {
                    /**Checking for application which can be viewed*/
                    var authorizedApplications = [];
                    if(data.applicationVsUserAcess) {
                        angular.forEach(data.applications, function(app) {
                            if(data.applicationVsUserAcess[app.EId]) {
                                authorizedApplications.push(app);
                            }
                        });
                    }
                    if(authorizedApplications.length === 0) {
                        if(!$scope.isRefer) {
                            $scope.backToCandList();
                        } else {
                            //As URL has rt param, it will take it to dashboard page
                            $scope.cancel();
                        }
                    }
                    else if(authorizedApplications.length === 1) {
                        //else we take them directly to the details page
                        $scope.goToCandDetails(authorizedApplications);
                    }
                    else{
                        //for cases where more than one application was created we show them a modal
                        $scope.candAppsModal = {};
                        $scope.candAppsModal.applications = authorizedApplications;
                        $scope.candAppsModal.show = true;
                        $scope.flags.loading = false;
                    }
                }
                return false;
            };

            $scope.backToCandList = function(){
                $window.location = $scope.candidateListUrl;
            };

            $scope.saveCandidateSuccess = function(data) {
                if(data && data.msgInfo === 200){
                    if(!$scope.isRefer) {
                        //Once candidate is created, BE will send candidateEId back,pass candidateEId in request to create contact
                        var candidateEId = data.candidateEId;
                        if(candidateEId){
                            //Candidate has been created. We can send the information to totango.
                            jvTotango.track('New Application Flow', 'Candidate');
                            candidates.getContactId(candidateEId, function(){
                                $scope.showCandApplicationsModal(data);
                            }, function(){
                                $scope.showCandApplicationsModal(data);
                            });
                        }else{
                            $scope.flags.loading = false;
                            $scope.showMsg('Unable to create contact!');
                        }
                    } else {
                        //Avoid calling contact EP when 'Refer-A-Friend' bug#22017
                        $scope.showCandApplicationsModal(data);
                    }
                }else{
                    $scope.flags.loading = false;
                    $scope.showMsg('Unable to perform requested operation!');
                }
            };

            $scope.cancel= function(){
                if($scope.formProperties.name !== 'agency') {
                    var _returnURL = $scope.urlParams().rt;
                    if($scope.isValidApplicationURL(_returnURL)) {
                        $window.location= decodeURIComponent(_returnURL);
                    }else {
                        $window.location = $scope.candidateListUrl;
                    }
                } else {
                    $window.close();
                }
            };
        }
    ]);
